import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
    selector: 'vas-calendar-button',
    template: `
        <button ion-button clear icon-only (click)="onClick($event)" #calendarButton>
            <ion-icon name="calendar"></ion-icon>
        </button>
    `
})
export class CalendarButtonComponent {
    @Input() accountId: string;
    @Input() disabled: boolean = false;
    @ViewChild('calendarButton', { read: ElementRef}) button: ElementRef;

    constructor(protected navController: NavController) {}

    onClick($event): void {
        if (this.isEventActionDisallowed($event)) {
            return;
        }

        this.navController.push('CalendarPageComponent', {
            accountId: this.accountId
        });
    }

    protected isEventActionDisallowed($event): boolean {
        const isEventFiredByButton = $event && $event.target === this.button.nativeElement.firstChild;
        return isEventFiredByButton && this.disabled;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/calendar-button/calendar-button.component.ts